export * from './service-call-summary.component';
export * from './service-call-summary.service';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/service-call/service-call-summary/index.ts